export default "__VITE_ASSET__dab805a1__"